import { heroStats, hotSearches } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="w-full bg-background-50 px-4 pb-4 pt-6 md:px-6 md:pt-10">
      <div className="relative mx-auto max-w-[1280px] overflow-hidden rounded-lg border border-background-200 bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20atmospheric%20illustrated%20banner%20of%20a%20dramatic%20Korean%20manhwa%20scene%2C%20silhouettes%20of%20heroes%20standing%20before%20a%20glowing%20monolith%20of%20overlapping%20comic%20panels%2C%20bold%20graphic%20novel%20style%2C%20deep%20shadowed%20dark%20background%20with%20vermilion%20and%20gold%20accents%2C%20cinematic%20lighting%2C%20subtle%20textures%2C%20high%20detail&width=1600&height=900&seq=manhwa-hero-bg&orientation=landscape"
          alt="韩国漫画高分神作推荐榜单首屏主视觉"
          title="韩国漫画推荐榜单 高分神作与豆瓣高分精选"
          className="absolute inset-0 h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/75 to-foreground-950/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent" />

        <div className="relative flex flex-col gap-8 px-6 py-10 md:px-12 md:py-16 lg:flex-row lg:items-center lg:justify-between lg:py-20">
          <div className="w-full max-w-2xl">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium text-background-100 backdrop-blur">
              <i className="ri-award-line text-accent-400" />
              2026 年度韩国漫画推荐榜单 · 每日更新
            </div>
            <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
              韩国漫画推荐榜单
              <span className="mt-2 block text-background-200">
                高分神作 · 人气榜 · 豆瓣高分精选全收录
              </span>
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-300 md:text-base">
              这里全面整理韩国漫画高分榜单，收录人气神作与豆瓣高分作品，涵盖热血、玄幻、悬疑、都市等各类题材。
              三个榜单交叉参考，帮你快速找到值得看的韩国漫画，告别书荒。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#featured"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-star-smile-line text-base" />
                查看高分神作榜
              </a>
              <a
                href="#popular"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                <i className="ri-fire-line text-base" />
                人气榜实时排行
              </a>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-2">
              <span className="text-xs text-background-400">大家都在搜</span>
              {hotSearches.slice(0, 4).map((word) => (
                <button
                  key={word}
                  type="button"
                  className="whitespace-nowrap rounded-full border border-background-50/15 bg-background-50/5 px-3 py-1 text-xs text-background-200 transition-colors hover:border-accent-400 hover:text-accent-400 cursor-pointer"
                >
                  {word}
                </button>
              ))}
            </div>
          </div>

          <div className="grid w-full grid-cols-2 gap-3 lg:w-[360px] lg:grid-cols-2 lg:gap-4">
            {heroStats.map((stat) => (
              <div
                key={stat.id}
                className="rounded-lg border border-background-50/12 bg-background-50/8 p-4 backdrop-blur"
              >
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{stat.value}</span>
                  <span className="text-xs text-accent-400">{stat.suffix}</span>
                </div>
                <div className="mt-1 text-xs text-background-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}